import React, { useState, useEffect } from "react";

export default function GymDatabase() {
  const images = [
    `${process.env.PUBLIC_URL}/Gym-Database.png`,
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="min-h-screen flex flex-col bg-gray-900 text-white px-2 md:px-8 pt-20"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Gym.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex-grow flex md:flex-row items-stretch justify-center gap-12 px-8 pt-20 md:flex mb-20">
        <div className="w-full md:w-1/2 hidden md:flex justify-center items-stretch">
          <img
            src={images[currentImage]}
            alt="Gym Database"
            className="w-full h-full rounded-2xl shadow-lg object-cover transition duration-1000"
          />
        </div>
        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-auto flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-purple-400 mb-6">Gym Database Management System</h1>
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            Designed and implemented a database management system to efficiently handle gym member records and subscriptions.
          </p>
          <ul className="list-disc list-outside pl-6 text-left text-gray-300 text-lg space-y-4 mb-6">
            <li>Database Design: Created normalized relational schemas using SQL to ensure data integrity and efficiency.</li>
            <li>Query Development: Implemented complex SQL queries for membership tracking, attendance, and subscription analysis.</li>
            <li>User Interface: Developed a simple Java GUI for easy data entry and management by gym administrators.</li>
            <li>Reporting: Generated detailed member activity and subscription reports for business insights.</li>
          </ul>
          <p className="text-gray-300 leading-relaxed text-lg mt-2">
            Streamlined membership management and improved operational efficiency for gym administration.
          </p>
        </div>
      </div>
    </div>
  );
}